var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from "react";
import styled from "styled-components";
import { H4, Body } from "@irati/ui/src/Typography";
import id from "@irati/utils/id";
import Flex from "@irati/ui/src/Flex";
import Spacing from "@irati/ui/src/Spacing";
var Wrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 65%;\n  > * {\n    &:not(:last-child) {\n      margin-right: 15px;\n    }\n  }\n"], ["\n  width: 65%;\n  > * {\n    &:not(:last-child) {\n      margin-right: 15px;\n    }\n  }\n"])));
var SettingsLink = function (props) {
    var title = props.title, value = props.value, children = props.children;
    var idNamespace = id("company-settings-title", props);
    return (React.createElement(Flex, { direction: "column", marginBottom: 4, id: idNamespace },
        React.createElement(Spacing, { marginBottom: 2 },
            React.createElement(H4, { marginBottom: 1, id: id("title", idNamespace) }, title),
            React.createElement(Body, { id: id("copy", idNamespace) }, value)),
        React.createElement(Wrapper, null, children)));
};
export default SettingsLink;
var templateObject_1;
